import { useEffect } from "react";;

const Logout = () => {
    const removeUser = () => {
        console.log("before logout")
        localStorage.removeItem("@MatriculaWeb:user");
        console.log("after logout")
    };

    useEffect(() => {
        removeUser();
    }, []);

    return (
        <>
        </>
    );
};

export default Logout;
